import $ from 'jquery'

const initializeBlock = function ($block) {
  const nav = $block.find('.intentions-block__nav')

  nav.on('click', function () {
    const currentNav = $(this)
    nav.removeClass('intentions-block__nav--active')
    currentNav.toggleClass('intentions-block__nav--active')

    const contents = $block.find('.intentions-block__nav-content')
    contents.slideUp(250)
    contents.eq(currentNav.index()).slideDown(250)
  })

  nav.eq(0).click()
}

$('.intentions-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=nrj-intentions', initializeBlock)
}


window.addEventListener('resize', setEqualHeight);

function setEqualHeight() {
  const navs = document.querySelectorAll('.intentions-block__nav');
  let maxHeight = 0;
  navs.forEach((nav) => {
    nav.style.height = 'auto';
  });
  navs.forEach((nav) => {
    if (nav.offsetHeight > maxHeight) {
      maxHeight = nav.offsetHeight;
    }
  });

  navs.forEach((nav) => {
    nav.style.height = `${maxHeight}px`;
  });
}

setEqualHeight();
